angular.module('wbDashboard').controller('ProfilePlanningControllerAurea',
    ['$scope', 'PlanningService', 'completedResolve',
function ($scope, PlanningService, completeResolve) {
    $scope.pageData.errorMsg = null;

    $scope.PlanningService = PlanningService;

    // $scope.$watch(function() { return PlanningService.getRecommendationInfo(); }, function(recommendationInfo) {
    //     if (recommendationInfo) {
    //         $scope.recommendationInfo = recommendationInfo;
    //         $scope.surveyPercent = $scope.recommendationInfo.surveys_completed_percent;
    //
    //     }
    // });

    $scope.$watch(function() { return PlanningService.getSurveysCompleted(); }, function(surveys) {
        //when updated after survey
        if (surveys) {
            $scope.surveys = surveys;
        }
    }, true);


    // $scope.$watch(function() { return PlanningService.getSurveysInfo(); }, function(surveys) {
    //     //when updated after survey
    //     if (surveys) {
    //         $scope.allSurveys = surveys;
    //     }
    // }, true);
    //
    // $scope.viewAll = function() {
    //     PlanningService.retrieveSurveysInfo();
    // };



}]);
